import {AngularFirestore} from '@angular/fire/firestore';
import {Injectable} from '@angular/core';
import {UnapModel} from '../model/unap.model';

@Injectable({
    providedIn: 'root'
})
export class UnapService {

    constructor(private db: AngularFirestore) {

    }
    public findAll() {
        return this.db.collection<UnapModel>('unap').valueChanges();
    }


}
